import { render, staticRenderFns } from "./MainMenuButton.vue?vue&type=template&id=3b4787ae&scoped=true"
import script from "./MainMenuButton.vue?vue&type=script&lang=js"
export * from "./MainMenuButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4787ae",
  null
  
)

export default component.exports